export const color = {
  red: 255,
  green: 255,
  blue: 255,
  alpha: 1,
  style: 'rgba(255, 255, 255, 1)'
};

export const gradient = {
  type: 'linear',
  style: 'linear-gradient(270deg, rgba(117, 117, 255, 1) 0%, rgba(0, 59, 128, 1) 100%)',
  degree: 270,
  points: [
    {
      left: 0,
      red: 117,
      green: 117,
      blue: 255,
      alpha: 1,
      style: 'rgba(117, 117, 255, 1)'
    },
    {
      left: 100,
      red: 59,
      green: 0,
      blue: 0,
      alpha: 1,
      style: 'rgba(59, 0, 0, 1)'
    }
  ]
};
